import { GenericModelApi } from "./GenericModelApi";
import { ApiError, ApiSchema } from "./ApiClient";
import { ProviderOrderFormData } from "@/formTypes/ProviderOrderDataType";
import { generateNextNumberByModel } from "@utils/Utils";
import { DocumentAutoGeneratedNumberApi } from "./DocumentAutoGeneratedNumberApi";

export type ProviderOrderDataType = Partial<ApiSchema["ProviderOrder"]["type"] & ProviderOrderFormData>;
class Api extends GenericModelApi<"ProviderOrder", ProviderOrderDataType> {

    async createProviderOrder(input: ProviderOrderDataType): Promise<ProviderOrderDataType> {
        let generatedNumber = await generateNextNumberByModel("ProviderOrder");
        if (!generatedNumber?.number) {
            throw Error(`No fue posible generar el identificador de la orden de compra`)
        }

        const { data, errors } = await this.model.create(
            {
                ...input,
                numero: generatedNumber?.number
            });
        if (errors) {
            throw new ApiError(`Errores al crear ${String(this.modelName)}`, "API_ERROR", errors);
        }

        await DocumentAutoGeneratedNumberApi.save(generatedNumber)

        return data || {} as ProviderOrderDataType;
    }


}
export const ProviderOrderApi = new Api("ProviderOrder", "numero", "ASC");